import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import {
  reducer as layoutReducer,
  STATE_KEY as LAYOUT_STATE_KEY,
} from "./components/Layout";
import {
  reducer as searchReducer,
  STATE_KEY as SEARCH_STATE_KEY,
} from "./components/Votify/VotifySearch";
import {
  reducer as partyReducer,
  STATE_KEY as PARTY_STATE_KEY,
} from "./components/Votify/VotifyParty";
import {
  reducer as socketReducer,
  STATE_KEY as SOCKET_STATE_KEY,
} from "./components/SocketIoComponent";
import {
  reducer as queueReducer,
  STATE_KEY as QUEUE_STATE_KEY,
} from "./components/Votify/VotifyQueue";
import {
  reducer as playbackReducer,
  STATE_KEY as PLAYBACK_STATE_KEY,
} from "./components/Votify/VotifyPlayback";
import {
  reducer as participantReducer,
  STATE_KEY as PARTICIPANT_STATE_KEY,
} from "./components/Votify/VotifyParticipant";
import {
  reducer as hostReducer,
  STATE_KEY as HOST_STATE_KEY,
} from "./components/Votify/VotifyHost";
import {
  reducer as preferencesReducer,
  STATE_KEY as PREFERENCES_STATE_KEY,
} from "./components/Preferences";
import {
  reducer as metaReducer,
  STATE_KEY as META_STATE_KEY,
} from "./components/Meta";

export default (history) =>
  combineReducers({
    [LAYOUT_STATE_KEY]: layoutReducer,
    [SEARCH_STATE_KEY]: searchReducer,
    [PARTY_STATE_KEY]: partyReducer,
    [SOCKET_STATE_KEY]: socketReducer,
    [QUEUE_STATE_KEY]: queueReducer,
    [PLAYBACK_STATE_KEY]: playbackReducer,
    [PARTICIPANT_STATE_KEY]: participantReducer,
    [HOST_STATE_KEY]: hostReducer,
    [PREFERENCES_STATE_KEY]: preferencesReducer,
    [META_STATE_KEY]: metaReducer,
    router: connectRouter(history),
  });
